import { twJoin } from 'tailwind-merge';

import { ProfileSectionHeader } from '@/components/profile/ProfileSectionHeader';
import { ProfileItemMeta, ProfileItemTitle } from '@/components/profile/ProfileText';
import { View } from '@/components/ui/view';
import { VStack } from '@/components/ui/vstack';

interface DisclosuresSectionProps {
  section: {
    title: string;
    data: readonly { title?: string; text?: string | null }[];
  };
  isFirstSection: boolean;
  isOwnProfile?: boolean;
  onEdit?: () => void;
}

export const DisclosuresSection = ({
  section,
  isFirstSection,
  isOwnProfile,
  onEdit,
}: DisclosuresSectionProps) => {
  return (
    <View>
      <ProfileSectionHeader title={section.title} isOwnProfile={isOwnProfile} onEdit={onEdit} />
      {section.data.map((item: any, itemIndex: number) => (
        <VStack
          className={twJoin(
            'mx-auto w-full max-w-5xl items-start px-6',
            section.data.length - 1 !== itemIndex ? 'mb-4' : ''
          )}
          key={`${item.title}-${itemIndex}`}>
          <ProfileItemTitle className="mb-1 leading-tight">{item.title}</ProfileItemTitle>
          {item.text?.split('\n').map((line: string, lineIndex: number) => {
            if (line.trim() === '') {
              return <View key={`empty-${lineIndex}`} className="h-4" />;
            }

            return (
              <ProfileItemMeta key={`${line}-${lineIndex}`} className="mb-1">
                {line}
              </ProfileItemMeta>
            );
          })}
        </VStack>
      ))}
    </View>
  );
};
